import React from 'react';
import { PainSection } from './PainSection';
import { ProductIntro } from './ProductIntro';
import { VolumesSection } from './VolumesSection';
import { BonusesSection } from './BonusesSection';
import { ValueStack } from './ValueStack';
import { AudienceSection } from './AudienceSection';
import { ProofSection } from './ProofSection';
import { HowItWorks } from './HowItWorks';
import { Reassurance } from './Reassurance';
import { ClosingBlock } from './ClosingBlock';
import { FAQ } from './FAQ';
import { Footer } from './Footer';
import { FloatingCTA } from './FloatingCTA';
export function DeferredLanding() {
  return <>
      <PainSection data-id="element-65" data-mp="11z83gzadu7ww" />
      <ProductIntro data-id="element-66" data-mp="121kmlfrvmobj" />
      <VolumesSection data-id="element-67" data-mp="x0wyp2yy2nlj" />
      <BonusesSection data-id="element-68" data-mp="x0dgrm9anz7i" />
      <ValueStack data-id="element-69" data-mp="x16n4m4ccmp4" />
      <AudienceSection data-id="element-70" data-mp="x2q4kg1qh3sh" />
      <ProofSection data-id="element-71" data-mp="1bxnzngo9o7d9" />
      <HowItWorks data-id="element-72" data-mp="1bx4hpzym9iz8" />
      <Reassurance data-id="element-73" data-mp="1bypd1rsr95y5" />
      <ClosingBlock data-id="element-74" data-mp="1by5rm13wbzfd" />
      <FAQ data-id="element-75" data-mp="16yt6bksob0ew" />
      <Footer data-id="element-76" data-mp="16z2zfh90lnot" />
      <div className="h-[54px] md:hidden" aria-hidden="true" data-id="element-77" data-mp="16zm43w9nmfkw" />
      <FloatingCTA data-id="element-78" data-mp="16wzyw3a8kc5u" />
    </>;
}